import { mdiChevronLeft, mdiClose } from '@mdi/js';
import _ from 'lodash';
import React, { useContext } from 'react';
import { MessagingContext } from '../../../services/messaging/context';
import { renderDate } from '../../data-table';
import { authorNickname, MessagingAuthorType } from '../util';
import * as S from './chat-header.styles';

interface IChatHeaderProps {
    onBack?: () => void;
}

export const ChatHeader: React.FunctionComponent<IChatHeaderProps> = ({ onBack }) => {
    const context = useContext(MessagingContext);
    const { message } = context;

    const authorType = _.get(message, 'author.type', '');

    const sourceLabel = (type: MessagingAuthorType): string => {
        switch (type) {
            case MessagingAuthorType.SUPPORT:
                return 'Enter Billing Team';
            case MessagingAuthorType.PROVIDER:
            case MessagingAuthorType.PATIENT:
            default:
                return '';
        }
    };

    const handleCloseClick = (): void => {
        context.onMessageClose && context.onMessageClose();
    };

    const handleBackClick = (): void => {
        onBack && onBack();
    };

    const nickname = authorNickname(message as any);
    
    return (
        <S.Header>
            {onBack && (
                <S.BackButton variant="fab-light" onClick={handleBackClick}>
                    <S.BackIcon path={mdiChevronLeft} size={1} />
                </S.BackButton>
            )}
            <S.HeaderLabels>
                {message && (
                    <>
                        {sourceLabel && <S.AuthorType type={authorType || undefined}>{sourceLabel(authorType as MessagingAuthorType)}</S.AuthorType>}
                        {!!nickname && (
                            <span>
                                From: <S.Value>{nickname}</S.Value>
                            </span>
                        )}
                    </>
                )}
            </S.HeaderLabels>
            <S.CloseButton variant="fab-light" onClick={handleCloseClick}>
                <S.CloseIcon path={mdiClose} size={1} />
            </S.CloseButton>
        </S.Header>
    );
};
